import { Loader2 } from "lucide-react";
import { Link } from "react-router";
import { useTranslations } from "use-intl";
import { Button } from "@/components/ui/button";

export function PageLoading() {
  return (
    <div className="flex flex-1 items-center justify-center py-24 text-muted-foreground">
      <Loader2 className="size-6 animate-spin" />
    </div>
  );
}

export function NotFound() {
  const t = useTranslations("common");
  return (
    <div className="mx-auto flex max-w-md flex-1 flex-col items-center justify-center gap-4 px-4 py-24 text-center">
      <p className="text-6xl font-black">404</p>
      <Button asChild>
        <Link to="/dashboard">{t("back")}</Link>
      </Button>
    </div>
  );
}
